import {
  createClinicalHistoryEndpoint,
  updateClinicalHistoryEndpoint,
  deleteClinicalHistoryEndpoint,
} from "./api/ClinicalHistory";

export const createClinicalHistory = async clinicalHistoryData => {
  try {
    const response = await createClinicalHistoryEndpoint(clinicalHistoryData);
    return response.data;
  } catch (error) {
    throw new Error(`Error creating clinical history: ${error.message}`);
  }
};

export const updateClinicalHistory = async (
  updatedClinicalHistoryData,
  clinicalHistoryId
) => {
  try {
    const response = await updateClinicalHistoryEndpoint(
      updatedClinicalHistoryData,
      clinicalHistoryId
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error updating clinical history: ${error.message}`);
  }
};

export const deleteClinicalHistory = async clinicalHistoryId => {
  try {
    const response = await deleteClinicalHistoryEndpoint(clinicalHistoryId);
    return response.data;
  } catch (error) {
    throw new Error(`Error deleting clinical history: ${error.message}`);
  }
};
